export default __webpack_public_path__ + "static/rebecca-levy-lewis-5068527f89e65153ea0eda7aeded5bbb.png";